// extracted by mini-css-extract-plugin
export default {"item":"LanguageSelector_item__ajGyG","activeItem":"LanguageSelector_activeItem__RWucc"};